import { useEffect } from "react";

// Internal test page — official Bsport widget code placed unchanged (per instruction).
export default function TestBsportMemberships() {
  useEffect(() => {
    const meta = document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, nofollow";
    document.head.appendChild(meta);

    // <script id="insert-bsport-widget-cdn"> — unchanged
    if (typeof window.BsportWidget === "undefined" && !document.getElementById("bsport-widget-cdn")) {
      const m = document.createElement("script");
      m.id = "bsport-widget-cdn";
      m.src = "https://cdn.bsport.io/scripts/widget.js";
      document.getElementsByTagName("head")[0].appendChild(m);
    }

    // <script id="bsport-widget-mount"> — unchanged
    function MountBsportWidget(config, repeat = 1) {
      if (repeat > 50) { return; }
      if (!window.BsportWidget) {
        return setTimeout(() => {
          MountBsportWidget(config, repeat + 1);
        }, 100 * repeat || 1);
      }
      window.BsportWidget.mount(config);
    }

    MountBsportWidget({
      "parentElement": "bsport-widget-486304",
      "companyId": 6040,
      "franchiseId": null,
      "dialogMode": 1,
      "widgetType": "subscription",
      "showFab": false,
      "fullScreenPopup": false,
      "styles": undefined,
      "config": {
        "subscription": {}
      }
    });

    return () => { document.head.removeChild(meta); };
  }, []);

  return (
    <section className="min-h-screen bg-petal" data-testid="bsport-test-page">
      <div className="mx-auto max-w-5xl px-6 pb-28 pt-32 md:px-12 md:pt-40">
        <h1 className="font-serif text-4xl md:text-5xl" data-testid="bsport-test-title">BSport Membership Widget Test</h1>
        <p className="mt-5 font-sans text-base text-onyx/60" data-testid="bsport-test-lead">
          Internal test page for Maison Core membership checkout flow.
        </p>
        <div id="bsport-widget-486304" className="mt-14 min-h-[640px]" data-testid="bsport-widget-container" />
      </div>
    </section>
  );
}
